var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInstagramColorful = function SvgInstagramColorful(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3792 8.47485H13.8926V10.0064H15.3792V8.47485Z",
    fill: "#2555EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4665 11.9832C14.4665 13.3437 13.3601 14.4507 12.0004 14.4507C10.6405 14.4507 9.53417 13.3437 9.53417 11.9832C9.53417 11.6151 9.61746 11.2666 9.76254 10.9524H8.13281V15.1881C8.13281 15.5726 8.44547 15.8854 8.82974 15.8854H15.1711C15.5554 15.8854 15.868 15.5726 15.868 15.1881V10.9526H14.2381C14.3832 11.2667 14.4665 11.6151 14.4665 11.9832Z",
    fill: "#2555EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 13.4507C12.8086 13.4507 13.4667 12.7924 13.4667 11.9832C13.4667 11.5817 13.3044 11.2177 13.0424 10.9524H10.9573C10.6954 11.2176 10.5332 11.5817 10.5332 11.9832C10.5332 12.7924 11.1912 13.4507 12 13.4507Z",
    fill: "#2555EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0005 2.36084C6.6802 2.36084 2.36719 6.67651 2.36719 11.9998C2.36719 17.323 6.6802 21.6392 12.0005 21.6392C17.3207 21.6392 21.6341 17.3232 21.6341 11.9998C21.6339 6.67651 17.3207 2.36084 12.0005 2.36084ZM16.8675 15.1882C16.8675 16.124 16.1066 16.8855 15.1711 16.8855H8.8298C7.8945 16.8855 7.13344 16.1242 7.13344 15.1882V8.81401C7.13344 7.87817 7.89434 7.11667 8.8298 7.11667H15.1711C16.1064 7.11667 16.8675 7.87801 16.8675 8.81401V15.1882Z",
    fill: "#2555EF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagramColorful, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InstagramColorful.1a14e06a.svg";
export { ForwardRef as ReactComponent };